const React = require("react");
const createReactClass = require("create-react-class");
const PT = require("prop-types");

const AssetsUtil = require("../util/AssetsUtil");

const PageBackdropImage = require("./PageBackdropImage");

const BACKDROP_IMAGES_TO_SIMPLIFY = ["hill-center", "hill-front-right"];

module.exports = createReactClass({
	displayName: "PageBackdrop",

	propTypes: {
		images: PT.array.isRequired,
		imageStyles: PT.object.isRequired,
		isSimplified: PT.bool,
	},

	getInitialState: function() {
		const images = this.props.images.map(item => {
			const isSimplified =
				BACKDROP_IMAGES_TO_SIMPLIFY.includes(item.imageName) &&
				this.props.isSimplified;
			return (
				<PageBackdropImage
					key={item.imageName}
					imageSrc={AssetsUtil.getHomescreenImage(item.imageName, isSimplified)}
					imageStyle={
						this.props.imageStyles[
							item.style + (isSimplified ? "Simplified" : "")
						]
					}
				/>
			);
		});
		return {
			images,
		};
	},

	render: function() {
		return <React.Fragment>{this.state.images || []}</React.Fragment>;
	},
});
